import React from "react";
import { Outlet } from "react-router-dom";
const PageUi = () => {
    return (
        <>
            <Outlet />
        </>
    );
};

export default PageUi;
